import { motion } from "framer-motion";
import { Reveal } from "../lib/motion";
import {
  Landmark, HeartPulse, Banknote, HardHat,
  Cpu, Shield, Zap, Building,
} from "lucide-react";

const INDUSTRIES = [
  { icon: Landmark, label: "Government" },
  { icon: HeartPulse, label: "Healthcare" },
  { icon: Banknote, label: "Financial Services" },
  { icon: HardHat, label: "Construction" },
  { icon: Cpu, label: "Technology" },
  { icon: Shield, label: "Defense" },
  { icon: Zap, label: "Energy" },
  { icon: Building, label: "Commercial" },
];

export default function Industries() {
  return (
    <section className="relative border-t border-white/5 bg-nexis-bg/70 py-28 backdrop-blur-sm md:py-36" data-testid="industries-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.25em] text-nexis-blue">— INDUSTRIES</span>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-light tracking-tight lg:text-5xl">
            Trusted where the <span className="text-gradient">stakes are highest</span>.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.label} delay={i * 0.05}>
              <motion.div
                whileHover={{ y: -6 }}
                className="glass glass-hover group flex flex-col items-center gap-4 rounded-3xl p-8 text-center"
                data-testid={`industry-${i}`}
              >
                <motion.div
                  className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/5 text-nexis-blue ring-1 ring-white/10"
                  whileHover={{ rotate: 360, scale: 1.08 }}
                  transition={{ duration: 0.8, ease: "easeInOut" }}
                >
                  <ind.icon className="h-6 w-6" />
                </motion.div>
                <span className="text-sm font-medium text-white/75">{ind.label}</span>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
